import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Input, DatePicker, Select } from "antd";
import Menubar from "../../components/SalesManager/App";
import { http } from "../../services/http";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import debounce from "lodash.debounce";
import { useTranslation } from "react-i18next";
import RowDataFinish from "../../components/SalesManager/row-data-shipment";
import moment from "moment";
import { get } from "lodash";
import HeaderWithInfinityScroll from "../../components/HeaderWithInfinityScroll";
const { RangePicker } = DatePicker;

const today = new Date();
const day = ("0" + today.getDate()).slice(-2);
const month = ("0" + (today.getMonth() + 1)).slice(-2);
const year = today.getFullYear();
const formattedDate = `${year}-${month}-${day}`;

const ShipmentItems = () => {
  const [fdata, setFData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const [docNum, setDocNum] = useState("");
  const [cardName, setCardName] = useState("");
  const [slpName, setSlpName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [docStatus, setDocStatus] = useState("O");
  const [docEntry, setDocEntry] = useState("");

  const [endDate, setEndDate] = useState(formattedDate);

  const [total, setTotal] = useState(0);

  const { t } = useTranslation();

  let searchInput = null;

  const fetchData = useCallback(
    async (
      page,
      ScardName,
      SdocNum,
      SslpName,
      SstartDate,
      SendDate,
      SdocStatus,
    ) => {
      try {
        let url = " ";
        setLoading(true);

        url = `api/yuklanganbuyurtmalar?${ScardName ? `cardName=${ScardName}&` : ""}${SdocNum ? `docNum=${SdocNum}&` : ""}${SslpName ? `slpName=${SslpName}&` : ""}${SstartDate ? `startDate=${SstartDate}&` : ""}endDate=${SendDate}&pageToken=${page}&docStatus=${SdocStatus}`;

        const { data } = await http.get(url);

        const formattedData = data.docs;

        const hasMore = formattedData.length === 20 ? true : false;
        setHasMoreData(hasMore);
        setTotal(get(data, "total", 0));
        if (page === 1) {
          setFData(formattedData);
        } else {
          setFData((prevData) => [...prevData, ...formattedData]);
        }
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    },
    [cardName, docNum, startDate, endDate, slpName, docStatus],
  );

  const handleDateRangeChange = (dates, confirm, dataIndex) => {
    debouncedSearch(dates, dataIndex, confirm);
  };

  const handleStartDate = (e) => {
    setCurrentPage(1);
    setStartDate(e.target.value);
  };

  const handleEndDate = (e) => {
    setCurrentPage(1);
    setEndDate(e.target.value);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value, dataIndex, confirm) => {
        if (dataIndex === "cardName") {
          if (value) {
            setCurrentPage(1);
            setCardName(value);
          } else {
            setCurrentPage(1);
            setCardName("");
          }
        } else if (dataIndex === "docNum") {
          if (value) {
            setCurrentPage(1);
            setDocNum(value);
          } else {
            setCurrentPage(1);
            setDocNum("");
          }
        } else if (dataIndex === "docStatus") {
          if (value) {
            setCurrentPage(1);
            setDocStatus(value);
          } else {
            setCurrentPage(1);
            setDocStatus("");
          }
        } else if (dataIndex === "slpName") {
          if (value) {
            setCurrentPage(1);
            setSlpName(value.toUpperCase());
          } else {
            setCurrentPage(1);
            setSlpName("");
          }
        } else {
        }

        confirm();
      }, 1500),
    [fetchData, currentPage],
  );

  const getColumnSearchProps = (dataIndex) => {
    if (dataIndex === "sana") {
      return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
          <div style={{ padding: 8 }}>
            <RangePicker
              value={selectedKeys && selectedKeys[0] ? selectedKeys : []}
              onChange={(dates) => {
                setSelectedKeys(dates ? dates : []);
                handleDateRangeChange(dates, confirm, dataIndex);
              }}
              style={{ marginBottom: 8, display: "block" }}
              disabledDate={(current) =>
                current && current > moment().endOf("day")
              }
            />
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) => {
          if (Array.isArray(value) && value.length === 2) {
            const [startDate, endDate] = value;
            const recordDate = moment(record[dataIndex]);
            return recordDate.isBetween(startDate, endDate, "[]");
          }
          return true;
        },
        render: (text) => text,
      };
    }

    if (dataIndex === "docStatus") {
      return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
          <div style={{ padding: 8 }}>
            <Select
              value={selectedKeys[0] || ""}
              onChange={(value) => {
                setSelectedKeys(value ? [value] : [""]);
                debouncedSearch(value, dataIndex, confirm);
              }}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            >
              <Select.Option value="">{t("all")}</Select.Option>
              <Select.Option value="O">{t("open")}</Select.Option>
              <Select.Option value="C">{t("closed")}</Select.Option>
            </Select>
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) => {
          if (value === "") {
            return true; // Show all records if the filter is set to 'All'
          }
          return record[dataIndex]
            ? record[dataIndex].toString().toLowerCase() === value.toLowerCase()
            : "";
        },
        render: (text) => text,
      };
    }

    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              searchInput = node;
            }}
            placeholder={`${t("search")} ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              handleSearch(e, confirm, dataIndex);
            }}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : "",
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.select(), 100);
        }
      },
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    };
  };

  const handleSearch = (e, confirm, dataIndex) => {
    const value = e.target.value;
    debouncedSearch(value, dataIndex, confirm);
  };

  const columns = [
    {
      title: t("mijoz"),
      dataIndex: "cardName",
      key: "cardName",
      ...getColumnSearchProps("cardName"),
    },
    {
      title: t("numZakazWhs"),
      dataIndex: "docNum",
      key: "docNum",
      ...getColumnSearchProps("docNum"),
    },
    {
      title: t("date"),
      dataIndex: "docDate",
      key: "docDate",
      render: (text) => {
        return moment(text).format("YYYY-MM-DD");
      },
    },
    {
      title: t("priceSum"),
      dataIndex: "docTotal",
      key: "docTotal",
      render: (text, record) => {
        const formatSum =
          record.docCur === "UZS"
            ? new Intl.NumberFormat("fr-FR").format(record.docTotalFC)
            : new Intl.NumberFormat("fr-FR").format(text);
        return `${formatSum} ${record.docCur}`;
      },
    },
    {
      title: t("creator"),
      dataIndex: "slpName",
      key: "slpName",
      ...getColumnSearchProps("slpName"),
    },

    // {
    //   title: t("Status"),
    //   dataIndex: "docStatus",
    //   key: "docStatus",
    //   ...getColumnSearchProps("docStatus"),

    //   render: (text) => (
    //     <span>
    //       {text === "C" ? t("closed") : text === "O" ? t("open") : text}
    //     </span>
    //   ),
    // },

    {
      title: t("driver"),
      dataIndex: "driverCardName",
      key: "driverCardName",
      render: (value) => (value ? value : "-"),
    },
  ];

  useEffect(() => {
    fetchData(
      currentPage,
      cardName,
      docNum,
      slpName,
      startDate,
      endDate,
      docStatus,
    );
  }, [
    fetchData,
    currentPage,
    cardName,
    docNum,
    slpName,
    startDate,
    endDate,
    docStatus,
  ]);

  const handleNextPage = () => {
    if (hasMoreData) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleRowClick = (record, index) => {
    console.log("index = ", index);
    setDocEntry(record.docEntry);
    setSelectedRowData(record);
    setIsModalVisible(true);
  };

  const closeCreateProductModal = () => {
    setIsModalVisible(false);
  };
  const refetch = () => {
    fetchData(
      currentPage,
      cardName,
      docNum,
      slpName,
      startDate,
      endDate,
      docStatus,
    );
  };

  return (
    <div className="flex h-full w-full overflow-y-auto">
      <Menubar />

      <HeaderWithInfinityScroll
        title={"shipments"}
        currentPage={currentPage}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
        hasMoreData={hasMoreData}
        columns={columns}
        fdata={fdata}
        loading={loading}
        handleRowClick={handleRowClick}
        onStartDateChange={handleStartDate}
        onEndDateChange={handleEndDate}
        startDate={startDate}
        endDate={endDate}
        formattedDate={moment().format("YYYY-MM-DD")}
        total={total}
      />
      <RowDataFinish
        visible={isModalVisible}
        data={selectedRowData}
        onClose={closeCreateProductModal}
        refetch={refetch}
        index={docEntry}
        onSuccess={(tableData) => {
          const newData = [...fdata];
          const data = newData
            .filter((row) => row.docEntry !== docEntry)
            .map((row) => {
              return row;
            });

          console.log("Post REsponse Data", data);
          setFData(data);
        }}
      />
    </div>
  );
};

export default ShipmentItems;
